
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/image-sharpener",
      function () {
        return require("private-next-pages/image-sharpener/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/image-sharpener"])
      });
    }
  